import { db, auth } from "../utils/init-firebase";
import MultiFirebaseService from "./MultiFirebase.service";
import { handleFirestoreError } from "../utils/firestoreIndexHandler";
import AuthenticatedApiService from "./AuthenticatedApiService";
import {
  doc,
  getDoc,
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  where,
  startAfter,
  endBefore,
  limit,
  setDoc,
  Timestamp,
  getCountFromServer,
} from "firebase/firestore";
// import { generateTrigam } from "../utils/trigamUtils";
// import { Timestamp } from "firebase/firestore";

//const dbCollection = db.collectionName("/contasgroups");

class GenericService {

  /**
   * Converte strings de data ISO de volta para objetos Timestamp do Firestore
   * Esta função é necessária porque a API retorna Date objects como strings ISO,
   * mas o cliente espera objetos Timestamp para compatibilidade
   */
  convertDateStringsToTimestamp = (obj) => {
    if (obj === null || obj === undefined) {
      return obj;
    }
    
    // Se for uma string que parece uma data ISO
    if (typeof obj === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(obj)) {
      try {
        const date = new Date(obj);
        return Timestamp.fromDate(date);
      } catch (error) {
        console.warn('Erro ao converter string para Timestamp:', obj, error);
        return obj;
      }
    }
    
    // Se for um array
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertDateStringsToTimestamp(item));
    }
    
    // Se for um objeto
    if (typeof obj === 'object' && obj.constructor === Object) {
      const converted = {};
      for (const [key, value] of Object.entries(obj)) {
        converted[key] = this.convertDateStringsToTimestamp(value);
      }
      return converted;
    }
    
    return obj;
  };

  getOne = async (collectionName, id, silentError = false) => {
    try {
      if (id) {
        const noteSnapshot = await getDoc(doc(db, collectionName, id.toString()));
        
        if (noteSnapshot.exists()) {
          const data = noteSnapshot.data();
          // console.log(collectionName, "id:", id, "=> noteSnapshot._document.version.timestamp.toDate()=", noteSnapshot._document.version.timestamp.toDate());
          // ✅ IMPORTANTE: Incluir o ID do documento no retorno para evitar perda de referência
          return {
            ...data,
            id: noteSnapshot.id
          };
        } else {
          throw new Error("Registro não encontrado! para o id: " + id + " na coleção: " + collectionName);
        }
      } else {
        return null;
      }
    } catch (error) {
      if (!silentError) {
        console.error("[GenericService] Erro ao buscar documento:", error);
      }
      throw error;
    }
  };
  //usage: getNote(id);
  getOneSnapshot = async (collectionName, id) => {
    // //console.log("GenericService.getOneSnapshot(", collectionName, ",", id, ")");
    try {
      if (id) {
        const noteSnapshot = await getDoc(doc(db, collectionName, id.toString()));
        if (noteSnapshot.exists()) {
          // //console.log("noteSnapshot.data()=", noteSnapshot.data());
          // console.log(collectionName, "=> noteSnapshot=", noteSnapshot);
          // console.log(collectionName, "=> noteSnapshot._document=", noteSnapshot._document);
          // console.log(collectionName, "id:", id, "=> noteSnapshot._document.createTime.timestamp.toDate()=", noteSnapshot._document.createTime.timestamp.toDate());
          // console.log(collectionName, "id:", id, "=> noteSnapshot._document.readTime.timestamp.toDate()=", noteSnapshot._document.readTime.timestamp.toDate());
          // console.log(collectionName, "id:", id, "=> noteSnapshot._document.version.timestamp.toDate()=", noteSnapshot._document.version.timestamp.toDate());
          return noteSnapshot;
        } else {
          throw new Error("Registro não encontrado!");
        }
      } else {
        return null;
      }
    } catch (error) {
      throw error;
    }
  };
  //usage: getOneSnapshot(id);

  getAll = async (collectionName, orderby, ascDesc, showAllStates) => {
    try {
      // console.log("GenericService.getAll(", collectionName, orderby, ascDesc, showAllStates, ")");
      let querySnapshot = [];
      
      // Valida os parâmetros
      if (!collectionName) {
        // console.error("Nome da coleção não fornecido");
        throw new Error("Nome da coleção não fornecido");
      }
      
      // Define valor padrão para orderby se não informado
      const effectiveOrderby = orderby || "name";
      const effectiveAscDesc = ascDesc || "asc";
      
      if (showAllStates) {
        querySnapshot = await getDocs(query(collection(db, collectionName), orderBy(effectiveOrderby, effectiveAscDesc)));
      } else {
        querySnapshot = await getDocs(query(collection(db, collectionName), where("metadados.active", "==", true), orderBy(effectiveOrderby, effectiveAscDesc)));
      }
      
      // console.log(`GenericService.getAll: Recuperados ${querySnapshot.docs.length} documentos`);
      return querySnapshot.docs;
    } catch (error) {
      console.error(`Erro em getAll para coleção ${collectionName}:`, error);
      await handleFirestoreError(error);
    }
  };
  // getFilteredCollectionSizeByVinculo = async (
  //   collectionName,
  //   filterTarget,
  //   operation,
  //   filterValue,
  //   orderby,
  //   ascDesc,
  //   vinculoIdEntidade
  // ) => {
  //   //console.log("getFilteredCollection(", collectionName, filterTarget, operation, filterValue, orderby, ascDesc, vinculoIdEntidade, ")");
  //   if (operation === "==") {
  //     const querySnapshot = await getDocs(
  //       query(
  //         collection(db, collectionName),
  //         where("metadados.active", "==", true),
  //         where(filterTarget, operation, filterValue),
  //         where("vinculo.idEntidade", "==", vinculoIdEntidade)
  //       )
  //     );
  //     return querySnapshot.docs.length;
  //   } else {
  //     // //console.log("orderby = ", orderby);
  //     if (orderby !== "") {
  //       const querySnapshot = await getDocs(
  //         query(
  //           collection(db, collectionName),
  //           where("metadados.active", "==", true),
  //           where(filterTarget, operation, filterValue),
  //           orderBy(orderby, ascDesc)
  //         )
  //       );
  //       return querySnapshot.docs.length;
  //     } else {
  //       // //console.log("Passou por aqui!!!");
  //       const querySnapshot = await getDocs(
  //         query(collection(db, collectionName), where("metadados.active", "==", true), where(filterTarget, operation, filterValue))
  //       );
  //       // //console.log("querySnapshot=", querySnapshot);
  //       return querySnapshot.docs.length;
  //     }
  //   }
  // };

  // getCollectionSizeByVinculo = async (collectionName, vinculoIdEntidade) => {
  //   const querySnapshot = await getDocs(
  //     query(collection(db, collectionName), where("metadados.active", "==", true), where("vinculo.idEntidade", "==", vinculoIdEntidade))
  //   );
  //   return querySnapshot.docs.length;
  // };

  getCollectionSize = async (collectionName) => {
    // const querySnapshot = await getDocs(query(collection(db, collectionName), where("metadados.active", "==", true)));
    // return querySnapshot.docs.length;
    const q = query(collection(db, collectionName), where("metadados.active", "==", true));
    const snapshot = await getCountFromServer(q);
    //console.log("count: ", snapshot.data().count);
    return snapshot.data().count;
  };

  getCollectionSizeInactive = async (collectionName) => {
    // const querySnapshot = await getDocs(query(collection(db, collectionName), where("metadados.active", "==", true)));
    // return querySnapshot.docs.length;
    const q = query(collection(db, collectionName), where("metadados.active", "==", false), where("successorId", "==", ""));
    const snapshot = await getCountFromServer(q);
    //console.log("count: ", snapshot.data().count);
    return snapshot.data().count;
  };

  getCollectionSizeWithActive = async (collectionName, active_true_false, aditionalCondition) => {
    // const querySnapshot = await getDocs(query(collection(db, collectionName), where("metadados.active", "==", true)));
    // return querySnapshot.docs.length;
    let conditions = [];
    if (active_true_false !== undefined && active_true_false !== null && active_true_false !== "") conditions.push(where("metadados.active", "==", active_true_false));
    conditions.push(where("metadados.successorId", "==", ""));
    if (aditionalCondition !== undefined && aditionalCondition !== null) conditions.push(aditionalCondition);
    // console.log("conditions=", conditions);
    const snapshot = await getCountFromServer(query(collection(db, collectionName), ...conditions));
    // const q = query(collection(db, collectionName), where("metadados.successorId", "==", ""));
    // const snapshot = await getCountFromServer(q);
    // console.log("count: ", snapshot.data().count);
    return snapshot.data().count;
  };

  getCollectionSizeWithActiveVersionZero = async (collectionName, active_true_false, aditionalCondition) => {
    // const querySnapshot = await getDocs(query(collection(db, collectionName), where("metadados.active", "==", true)));
    // return querySnapshot.docs.length;
    let conditions = [];
    if (active_true_false !== undefined && active_true_false !== null && active_true_false !== "") conditions.push(where("metadados.active", "==", active_true_false));
    conditions.push(where("metadados.successorId", "==", ""));
    conditions.push(where("metadados.version", "in", [0, 1]));
    if (aditionalCondition !== undefined && aditionalCondition !== null) conditions.push(aditionalCondition);
    const snapshot = await getCountFromServer(query(collection(db, collectionName), ...conditions));
    // const q = query(collection(db, collectionName), where("metadados.successorId", "==", ""));
    // const snapshot = await getCountFromServer(q);
    // console.log("count: ", snapshot.data().count);
    return snapshot.data().count;
  };

  getFilteredCollectionSizeWithActive = async (collectionName, filterTarget, operation, filterValue, orderby, ascDesc, active_true_false, aditionalCondition) => {
    // console.log("getFilteredCollectionSizeWithActive(", collectionName, filterTarget, operation, filterValue, orderby, ascDesc, active_true_false, ")");
    try {
      let conditions = [];
      if (active_true_false !== undefined && active_true_false !== null && active_true_false !== "") conditions.push(where("metadados.active", "==", active_true_false));
      conditions.push(where(filterTarget, operation, filterValue));
      conditions.push(where("metadados.successorId", "==", ""));
      if (aditionalCondition !== undefined && aditionalCondition !== null) conditions.push(aditionalCondition);
      if (orderby !== undefined && orderby !== null && orderby !== "") {
        conditions.push(orderBy(orderby, ascDesc));
      }
      // console.log("conditions=", conditions);
      // const querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
      const snapshot = await getCountFromServer(query(collection(db, collectionName), ...conditions));
      // console.log("count: ", snapshot.data().count);
      return snapshot.data().count;
    } catch (error) {
      await handleFirestoreError(error);
    }
  };

  getDoubleFilteredCollectionSizeWithActive = async (collectionName, filterTarget, operation, filterValue, filterTarget2nd, operation2nd, filterValue2nd, orderby, ascDesc, active_true_false, aditionalCondition) => {
    // console.log("getFilteredCollectionSizeWithActive(", collectionName, filterTarget, operation, filterValue, orderby, ascDesc, active_true_false, ")");
    try {
      let conditions = [];
      if (active_true_false !== undefined && active_true_false !== null && active_true_false !== "") conditions.push(where("metadados.active", "==", active_true_false));
      conditions.push(where(filterTarget, operation, filterValue));
      conditions.push(where(filterTarget2nd, operation2nd, filterValue2nd));
      conditions.push(where("metadados.successorId", "==", ""));
      if (aditionalCondition !== undefined && aditionalCondition !== null) conditions.push(aditionalCondition);
      if (orderby !== undefined && orderby !== null && orderby !== "") {
        conditions.push(orderBy(orderby, ascDesc));
      }
      // const querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
      const snapshot = await getCountFromServer(query(collection(db, collectionName), ...conditions));
      // console.log("count: ", snapshot.data().count);
      return snapshot.data().count;
    } catch (error) {
      await handleFirestoreError(error);
    }
  };

  // getFilteredCollectionByVinculo = async (collectionName, filterTarget, operation, filterValue, orderby, ascDesc, vinculoIdEntidade) => {
  //   //console.log("getFilteredCollection(", collectionName, filterTarget, operation, filterValue, orderby, ascDesc, vinculoIdEntidade, ")");
  //   if (operation === "==") {
  //     const querySnapshot = await getDocs(
  //       query(
  //         collection(db, collectionName),
  //         where("metadados.active", "==", true),
  //         where(filterTarget, operation, filterValue),
  //         where("vinculo.idEntidade", "==", vinculoIdEntidade)
  //       )
  //     );
  //     return querySnapshot.docs;
  //   } else {
  //     // //console.log("orderby = ", orderby);
  //     if (orderby !== "") {
  //       const querySnapshot = await getDocs(
  //         query(
  //           collection(db, collectionName),
  //           where("metadados.active", "==", true),
  //           where(filterTarget, operation, filterValue),
  //           orderBy(orderby, ascDesc)
  //         )
  //       );
  //       return querySnapshot.docs;
  //     } else {
  //       // //console.log("Passou por aqui!!!");
  //       const querySnapshot = await getDocs(
  //         query(collection(db, collectionName), where("metadados.active", "==", true), where(filterTarget, operation, filterValue))
  //       );
  //       // //console.log("querySnapshot=", querySnapshot);
  //       return querySnapshot.docs;
  //     }
  //   }
  // };
  // getConditionsFromQueryFilter = (queryTarget, queryFilter) => {
  //   const conditions = [];
  //   if (typeof queryFilter === "object") {
  //     if (queryFilter !== undefined) {
  //       if (queryFilter.situacaoSearch !== "Todas") {
  //         conditions.push(where("situacao", "==", queryFilter.situacaoSearch));
  //       }
  //       if (queryTarget.includes("trigam")) {
  //         conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryFilter.searchInfo).slice(0, 10)]));
  //         if (queryFilter.searchInfo) {
  //           if (queryFilter.searchInfo.length > 0) conditions.push(orderBy(queryTarget, "asc"));
  //         }
  //       } else if (queryFilter.searchInfo.length > 0) {
  //         conditions.push(where(queryTarget, "==", queryFilter.searchInfo));
  //       }
  //     } else {
  //       // //console.log("queryFilter=", queryFilter);
  //     }
  //   } else if (typeof queryFilter === "string") {
  //     if (queryFilter.length > 0) {
  //       if (queryTarget.includes("trigam")) {
  //         conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryFilter)]));
  //         if (queryFilter.searchInfo) {
  //           if (queryFilter.searchInfo.length > 0) conditions.push(orderBy(queryTarget, "asc"));
  //         }
  //       } else conditions.push(where(queryTarget, "==", queryFilter));
  //     }
  //   }
  //   return conditions;
  // };

  getFilteredCollection = async (collectionName, filterTarget, operation, filterValue, orderby, ascDesc) => {
    try {
      // Valida os parâmetros obrigatórios
      if (!collectionName) {
        console.error("❌ [Generic.service] Nome da coleção não fornecido");
        throw new Error("Nome da coleção não fornecido");
      }
      
      // Define valores padrão (respeita strings vazias como "sem ordenação")
      const effectiveFilterTarget = filterTarget || "name";
      const effectiveOperation = operation || "==";
      const effectiveAscDesc = ascDesc || "asc";
      
      // Prepara as condições de busca
      let conditions = [];
      conditions.push(where("metadados.active", "==", true));
      
      // Adiciona filtro apenas se houver valor definido
      if (filterValue !== undefined && filterValue !== null && filterValue !== "") {
        if (effectiveOperation === "contains") {
          // Para operação "contains", implementamos uma busca por prefixo
          const endValue = filterValue + "\uf8ff"; // Sufixo Unicode para representar qualquer caractere
          conditions.push(where(effectiveFilterTarget, ">=", filterValue));
          conditions.push(where(effectiveFilterTarget, "<=", endValue));
        } else {
          conditions.push(where(effectiveFilterTarget, effectiveOperation, filterValue));
        }
      }
      
      // Adiciona ordenação apenas se orderby foi explicitamente fornecido
      if (orderby !== undefined && orderby !== null && orderby !== "") {
        conditions.push(orderBy(orderby, effectiveAscDesc));
      }
      
      // Executa a consulta
      try {
        const querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
        return querySnapshot.docs;
      } catch (firestoreError) {
        console.error("❌ [Generic.service] Firestore query FAILED:", {
          collection: collectionName,
          error: firestoreError.message,
          errorCode: firestoreError.code
        });
        await handleFirestoreError(firestoreError);
      }
    } catch (error) {
      console.error(`❌ [DIAGNOSTIC] getFilteredCollection OUTER ERROR for ${collectionName}:`, {
        message: error.message,
        code: error.code,
        stack: error.stack,
        timestamp: new Date().toISOString()
      });
      throw error;
    }
  };


  getFilteredCollectionWithActive = async (collectionName, filterTarget, operation, filterValue, orderby, ascDesc, active_true_false) => {
    // //console.log("getFilteredCollection(", collectionName, filterTarget, operation, filterValue, orderby, ascDesc, active_true_false, ")");
    let conditions = [];
    if (active_true_false !== undefined && active_true_false !== null && active_true_false !== "") conditions.push(where("metadados.active", "==", active_true_false));
    conditions.push(where(filterTarget, operation, filterValue));
    if (orderby !== undefined && orderby !== null && orderby !== "") {
      conditions.push(orderBy(orderby, ascDesc));
    }
    const querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    return querySnapshot.docs;
  };

  getDoubleFilteredCollection = async (collectionName, filterTarget, operation, filterValue, filterTarget2, operation2, filterValue2, orderby, ascDesc) => {
    // console.log("getDoubleFilteredCollection(", collectionName, filterTarget, operation, filterValue, filterTarget2, operation2, filterValue2, orderby, ascDesc, ")");
    let conditions = [];
    conditions.push(where("metadados.active", "==", true));
    conditions.push(where(filterTarget, operation, filterValue));
    conditions.push(where(filterTarget2, operation2, filterValue2));
    if (orderby !== undefined && orderby !== null && orderby !== "") {
      conditions.push(orderBy(orderby, ascDesc));
    }
    // console.log("conditions=", conditions);
    const querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    return querySnapshot.docs;
  };

  // getCollectionSearchByPrefix = async (collectionName, queryTarget, queryText, orderby, ascDesc) => {
  //   // //console.log("getCollectionSearchByPrefix(", collectionName, queryTarget, queryText, orderby, ascDesc, ")");
  //   // //console.log(collectionName, queryTarget, queryText, orderby, ascDesc);

  //   //console.log(queryTarget, queryText);
  //   let conditions = [];
  //   if (queryText.length > 0) {
  //     if (["%", "*", "?"].includes(queryText.substring(0, 1))) {
  //       queryText = queryText.substring(1, queryText.length);
  //       queryText = queryText.trim().toLowerCase().replaceAll("  ", " ");
  //       conditions.push(where(queryTarget, "array-contains-any", [...generateTrigam(queryText).slice(0, 10)]));
  //       if (queryText.searchInfo) {
  //         if (queryText.searchInfo.length > 0) conditions.push(orderBy(queryTarget, "asc"));
  //       }
  //     } else {
  //       queryTarget = queryTarget.replace("trigam", "name");
  //       conditions.push(where(queryTarget, ">=", queryText));
  //       conditions.push(where(queryTarget, "<=", queryText + "\uf8ff"));
  //     }
  //   }

  //   const querySnapshot = await getDocs(
  //     query(collection(db, collectionName), where("metadados.active", "==", true), ...conditions, orderBy(orderby, ascDesc))
  //   );
  //   return querySnapshot.docs;
  // };

  getPrevPage = async (collectionName, firstVisible, pageSize, orderby, ascDesc, vinculo_idEntidade) => {
    // //console.log(
    //   "collectionName=",
    //   collectionName,
    //   " firstVisible=",
    //   firstVisible,
    //   " pageSize=",
    //   pageSize,
    //   " orderby=",
    //   orderby,
    //   " ascDesc=",
    //   ascDesc,
    //   " vinculo_idEntidade=",
    //   vinculo_idEntidade
    // );
    const conditions = [];
    if (vinculo_idEntidade) if (vinculo_idEntidade !== null) conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
    conditions.push(where("metadados.active", "==", true));
    conditions.push(orderBy(orderby, ascDesc));
    if (pageSize !== null) conditions.push(limit(pageSize));
    if (firstVisible !== undefined && firstVisible !== null && firstVisible !== "") conditions.push(endBefore(firstVisible));
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    return querySnapshot.docs;
  };

  getNextPage = async (collectionName, lastVisible, pageSize, orderby, ascDesc, vinculo_idEntidade) => {
    // //console.log(
    //   "collectionName=",
    //   collectionName,
    //   " lastVisible=",
    //   lastVisible,
    //   " pageSize=",
    //   pageSize,
    //   " orderby=",
    //   orderby,
    //   " ascDesc=",
    //   ascDesc,
    //   " vinculo_idEntidade=",
    //   vinculo_idEntidade
    // );
    const conditions = [];
    if (vinculo_idEntidade) if (vinculo_idEntidade !== null) conditions.push(where("vinculo.idEntidade", "==", vinculo_idEntidade));
    conditions.push(where("metadados.active", "==", true));
    conditions.push(orderBy(orderby, ascDesc));
    if (pageSize !== null) conditions.push(limit(pageSize));
    if (lastVisible !== undefined && lastVisible !== null && lastVisible !== "") conditions.push(startAfter(lastVisible));
    //console.log("conditions=", conditions);
    let querySnapshot = await getDocs(query(collection(db, collectionName), ...conditions));
    return querySnapshot.docs;
  };

  create = async (collectionName, value) => {
    try {
      // Pegar o database correto baseado na collection
      const connection = MultiFirebaseService.getConnection(collectionName);
      const targetDb = connection?.db || db;
      
      // //console.log("GenericService.create(", collectionName, value, ")");
      return await addDoc(collection(targetDb, collectionName), value)
        .then(async (docRef) => {
          return await getDoc(docRef)
            .then(async (doc) => {
              return doc;
            })
            .catch((error) => {
              throw error;
            });
        })
        .catch((error) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  };

  createWithID = async (collectionName, UID, value) => {
    try {
      // console.log("GenericService.createWithID(", collectionName, UID, value, ")");
      if (isNaN(value.metadados.creation)) value.metadados.creation = Timestamp.fromDate(new Date());
      return setDoc(doc(db, collectionName, UID.toString()), value);
    } catch (error) {
      throw error;
    }
  };

  createOrUpdate = async (collectionName, UID, value) => {
    try {
      return await this.getOne(collectionName, UID).then(async (retData) => {
        if (retData) {
          return await this.update(collectionName, UID, value);
        } else {
          return await this.createWithID(collectionName, UID, value);
        }
      }).catch((error) => {
        throw error;
      });
    } catch (error) {
      throw error;
    }
  };
  
  /**
   * Cria um novo documento ou adiciona dados a um array no documento existente
   * @param {string} collectionName - Nome da coleção
   * @param {string} UID - ID do documento
   * @param {Object} value - Objeto a ser adicionado
   * @param {string} arrayField - Nome do campo array (padrão: 'items')
   * @returns {Promise} - Promessa resolvida após operação
   */
  createOrAppend = async (collectionName, UID, value, arrayField = 'items') => {
    try {
      
      let docRef = doc(db, collectionName, UID.toString());
      let docSnap;
      
      try {
        docSnap = await getDoc(docRef);
      } catch (error) {
        docSnap = null;
      }
      
      if (docSnap && docSnap.exists()) {
        // Documento existe, adiciona o valor ao array
        const docData = docSnap.data();
        
        // Se o campo array não existir, cria como array vazio
        if (!docData[arrayField]) {
          docData[arrayField] = [];
        }
        
        // Adiciona o novo item ao array
        docData[arrayField].push(value);
        
        // Atualiza o documento
        return await updateDoc(docRef, {
          [arrayField]: docData[arrayField],
          'metadados.lastUpdate': Timestamp.fromDate(new Date())
        });
      } else {
        // Documento não existe, cria com o valor em um array
        const newDoc = {
          [arrayField]: [value],
          metadados: {
            creation: Timestamp.fromDate(new Date()),
            version: 1,
            active: true,
            successorId: ""
          }
        };
        
        return await setDoc(docRef, newDoc);
      }
    } catch (error) {
      console.error(`Erro em createOrAppend: ${error.message}`, error);
      throw error;
    }
  };

  update = async (collectionName, id, value) => {
    // console.log("GenericService.update(", collectionName, id, value, ")");
    try {
      return await this.getOne(collectionName, id)
        .then(async (retData) => {
          let oldVersion = {
            ...retData,
            metadados: {
              ...retData.metadados,
              active: false,
              successorId: id,
            },
          };
          // console.log("oldVersion=", oldVersion, "value.metadados=", value.metadados);
          return await addDoc(collection(db, collectionName), oldVersion)
            .then(async (lastVersion) => {
              let ActualVersion = {
                ...value,
                metadados: {
                  ...value.metadados,
                  version: oldVersion.metadados.version + 1,
                  successorId: "",
                },
              };
              // console.log("ActualVersion=", ActualVersion);
              return await updateDoc(doc(db, collectionName, id.toString()), ActualVersion, { merge: true })
                .then((docRef) => {
                  // console.log("docRef=", docRef);
                  return docRef;
                })
                .catch((error) => {
                  throw error;
                });
            })
            .catch((error) => {
              throw error;
            });
        })
        .catch((error) => {
          throw error;
        });
    } catch (error) {
      console.error('Erro ao processar dados financeiros:', error);
      throw error;
    }
  };


  /**
   * Ativa/inativa um documento alterando apenas metadados.active in-place,
   * sem criar versionamento (diferente de update()).
   */
  setActiveState = async (collectionName, id, activeValue) => {
    try {
      return await updateDoc(doc(db, collectionName, id.toString()), {
        "metadados.active": activeValue,
        "metadados.date": Timestamp.fromDate(new Date()),
      });
    } catch (error) {
      console.error(`[setActiveState] Erro ao alterar estado de ${collectionName}/${id}:`, error);
      throw error;
    }
  };

  updateReplacingData = async (collectionName, id, value) => {
    try {
      // 🛡️ SEGURANÇA: Validar que o novo valor tem campos suficientes
      // para evitar sobrescrita catastrófica com dados parciais.
      // setDoc() sem merge SUBSTITUI o documento inteiro.
      const fieldCount = Object.keys(value || {}).length;
      if (fieldCount < 3) {
        console.error(`🚨 [updateReplacingData] BLOQUEADO: tentativa de sobrescrever ${collectionName}/${id} com apenas ${fieldCount} campos.`);
        throw new Error(
          `Operação bloqueada: updateReplacingData requer pelo menos 3 campos de nível superior. ` +
          `Recebido: ${fieldCount}. Isso previne sobrescrita acidental de dados.`
        );
      }

      return await this.getOne(collectionName, id)
        .then(async (retData) => {
          // 🛡️ Verificar se o documento existente tem significativamente mais dados
          const existingFieldCount = Object.keys(retData || {}).length;
          if (existingFieldCount > 0 && fieldCount < existingFieldCount * 0.5) {
            console.warn(
              `⚠️ [updateReplacingData] ALERTA: ${collectionName}/${id} — ` +
              `documento existente tem ${existingFieldCount} campos, ` +
              `novo valor tem apenas ${fieldCount}. Possível perda de dados.`
            );
          }

          let oldVersion = {
            ...retData,
            metadados: {
              ...retData.metadados,
              active: false,
              successorId: id,
            },
          };
          return await addDoc(collection(db, collectionName), oldVersion)
            .then(async (lastVersion) => {
              let ActualVersion = {
                ...value,
                metadados: {
                  ...value.metadados,
                  version: value.metadados.version + 1,
                  successorId: "",
                },
              };
              return await setDoc(doc(db, collectionName, id.toString()), ActualVersion)
                .then((docRef) => {
                  return docRef;
                })
                .catch((error) => {
                  throw error;
                });
            })
            .catch((error) => {
              throw error;
            });
        })
        .catch((error) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  };

  updateWithoutVersioning = async (collectionName, id, value) => {
    // console.log("GenericService.update(", collectionName, id, value, ")");
    try {
      return await updateDoc(doc(db, collectionName, id.toString()), value, { merge: true })
        .then((docRef) => {
          // //console.log("docRef=", docRef);
          return docRef;
        })
        .catch((error) => {
          throw error;
        });
    } catch (error) {
      throw error;
    }
  };

  updateAndVersioning = async (collectionName, id, value) => {
    try {
      await updateDoc(doc(db, collectionName, id.toString()), { ["metadados.active"]: false }, { merge: true });
      return await addDoc(collection(db, collectionName), value);
    } catch (error) {
      throw error;
    }
  };

  updateFederativeActiveState = async (collectionName, id, newStateValue, userId, userName) => {
    try {
      const retData = await this.getOne(collectionName, id);
      if (!retData) throw new Error(`Documento não encontrado: ${collectionName}/${id}`);

      // 1. Cria backup da versão atual (antes da mudança), marcando-a como sucedida pelo original
      const backup = {
        ...retData,
        metadados: {
          ...retData.metadados,
          active: false,       // Versões históricas são sempre inativas
          successorId: id,     // Aponta para o documento original (atual)
        },
      };
      await addDoc(collection(db, collectionName), backup);

      // 2. Atualiza o original num único write, sem estado intermediário
      const updateFields = {
        "metadados.federativeactive": newStateValue,
        "metadados.successorId": "",
        "metadados.version": (retData.metadados?.version || 0) + 1,
      };
      if (userId !== undefined && userId !== null) {
        updateFields["metadados.ownerid"] = userId;
        updateFields["metadados.owner"] = userName || "usuário";
      }
      return await updateDoc(doc(db, collectionName, id.toString()), updateFields, { merge: true });
    } catch (error) {
      console.error(`Erro ao atualizar estado federativo para ${collectionName}/${id}:`, error);
      throw error;
    }
  };

  updateActiveState = async (collectionName, id, newStateValue, userId, userName) => {
    try {
      const retData = await this.getOne(collectionName, id);
      if (!retData) throw new Error(`Documento não encontrado: ${collectionName}/${id}`);

      // 1. Cria backup da versão atual (antes da mudança), marcando-a como sucedida pelo original
      const backup = {
        ...retData,
        metadados: {
          ...retData.metadados,
          active: false,       // Versões históricas são sempre inativas
          successorId: id,     // Aponta para o documento original (atual)
        },
      };
      await addDoc(collection(db, collectionName), backup);

      // 2. Atualiza o original num único write, sem estado intermediário
      const updateFields = {
        "metadados.active": newStateValue,
        "metadados.successorId": "",
        "metadados.version": (retData.metadados?.version || 0) + 1,
      };
      if (userId !== undefined && userId !== null) {
        updateFields["metadados.ownerid"] = userId;
        updateFields["metadados.owner"] = userName || "usuário";
      }
      return await updateDoc(doc(db, collectionName, id.toString()), updateFields, { merge: true });
    } catch (error) {
      console.error(`Erro ao atualizar estado ativo para ${collectionName}/${id}:`, error);
      throw error;
    }
  };

  updateProperty = async (collectionName, id, propertyName, propertyValue) => {
    // console.log("updateProperty(", collectionName, id, propertyName, propertyValue, ")");
    await this.doCollectionRevision(collectionName, id);
    return await updateDoc(doc(db, collectionName, id), { [propertyName]: propertyValue }, { merge: true })
      .then((retValue) => {
        return retValue;
      }).catch((error) => {
        throw error;
      });
  };

  /**
   * Irmão de updateProperty() que NÃO reescreve o campo `id` do documento.
   *
   * Por que existe: updateProperty() → doCollectionRevision() → update() grava de volta
   * o objeto devolvido por getOne(), e getOne() injeta `id: <docId>` no retorno. Em
   * coleções onde `id` é campo de negócio — `portais.id` é o número canônico do portal
   * (1 Notícias, 3 Transparência, 4 Institucional) — cada gravação substituía esse
   * número pelo docId, e o portal da federação sumia das telas que buscam por id == 3.
   *
   * Este método lê o documento cru (sem o `id` injetado), versiona a cópia anterior do
   * mesmo jeito que update() faz e grava apenas a propriedade pedida. O campo `id`
   * nunca entra no payload, então o valor gravado permanece intacto.
   *
   * Mantido separado de propósito: update()/updateProperty() são usados em todo o
   * sistema desde 2023 e não devem mudar de comportamento por causa deste caso.
   */
  updatePropertyPreservingId = async (collectionName, id, propertyName, propertyValue) => {
    const docRef = doc(db, collectionName, id.toString());
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) {
      throw new Error("Registro não encontrado! para o id: " + id + " na coleção: " + collectionName);
    }
    const atual = snapshot.data();

    // Cópia versionada da versão anterior (mesma semântica de update()).
    await addDoc(collection(db, collectionName), {
      ...atual,
      metadados: {
        ...atual.metadados,
        active: false,
        successorId: id.toString(),
      },
    });

    return await updateDoc(docRef, {
      [propertyName]: propertyValue,
      "metadados.version": (atual.metadados?.version ?? 0) + 1,
      "metadados.successorId": "",
    });
  };

  updateObject = async (collectionName, id, obj) => {
    await this.doCollectionRevision(collectionName, id);
    updateDoc(doc(db, collectionName, id), obj, { merge: true })
      .then((retValue) => {
        return retValue;
      }).catch((error) => {
        throw error;
      });
  };

  doCollectionRevision = async (collectionName, id) => {
    let previousVersion = await this.getOne(collectionName, id);
    if (previousVersion) {
      await this.update(collectionName, id, previousVersion);
    }
  };

  updateObjectInsideCollection = async (collectionName, id, collectionObjectName, obj) => {
    // console.log("updateObjectInsideCollection(", collectionName, id, collectionObjectName, obj, ")");
    try {
      await this.doCollectionRevision(collectionName, id);
      let oldCollection = await this.getOne(collectionName, id);
      if (oldCollection) {
        // console.log("oldCollection=", oldCollection);
        // console.log("collectionObjectName=", collectionObjectName);
        // console.log("oldCollection[collectionObjectName]=", oldCollection[collectionObjectName]);
        // console.log("[...oldCollection[collectionObjectName], obj]=", [...oldCollection[collectionObjectName], obj]);
        return await this.updateObject(collectionName, id, { [collectionObjectName]: [...oldCollection[collectionObjectName], obj] });
      }
    } catch (error) {
      throw error;
    }
  };

  insertNewObjectInsideCollection = async (collectionName, id, collectionObjectName, obj) => {
    try {
      await this.doCollectionRevision(collectionName, id);
      let oldCollection = await this.getOne(collectionName, id);
      if (oldCollection) {
        // console.log("oldCollection=", oldCollection);
        // console.log("collectionObjectName=", collectionObjectName);
        // console.log("oldCollection[collectionObjectName]=", oldCollection[collectionObjectName]);
        // console.log("[...oldCollection[collectionObjectName], obj]=", [...oldCollection[collectionObjectName], obj]);
        return await this.updateObject(collectionName, id, { [collectionObjectName]: [...oldCollection[collectionObjectName], obj] });
      }
    } catch (error) {
      throw error;
    }
  };

  updateObjectInsideCollectionByIndex = async (collectionName, id, collectionObjectName, index, obj) => {
    // console.log("updateObjectInsideCollection(", collectionName, id, collectionObjectName, index, obj, ")");
    try {
      await this.doCollectionRevision(collectionName, id);
      let oldCollection = await this.getOne(collectionName, id);
      if (oldCollection) {
        // console.log("oldCollection=", oldCollection);
        // console.log("collectionObjectName=", collectionObjectName);
        // console.log("oldCollection[collectionObjectName]=", oldCollection[collectionObjectName]);
        // console.log("[...oldCollection[collectionObjectName], obj]=", [...oldCollection[collectionObjectName], obj]);
        // return await this.updateObject(collectionName, id, { [collectionObjectName]: [...oldCollection[collectionObjectName], obj] });
        let newCollection = oldCollection[collectionObjectName];
        // console.log("newCollection=", newCollection);
        newCollection[index] = obj;
        // console.log("newCollection=", newCollection);
        return await this.updateObject(collectionName, id, { [collectionObjectName]: newCollection });
      }
    } catch (error) {
      throw error;
    }
  };

  deleteObjectInsideCollection = async (collectionName, id, collectionObjectName, index) => {
    // console.log("deleteObjectInsideCollection(", collectionName, id, collectionObjectName, index, ")");
    try {
      await this.doCollectionRevision(collectionName, id);
      let oldCollection = await this.getOne(collectionName, id);
      if (oldCollection) {
        // console.log("oldCollection=", oldCollection);
        // console.log("collectionObjectName=", collectionObjectName);
        // console.log("oldCollection[collectionObjectName]=", oldCollection[collectionObjectName]);
        let newCollection = oldCollection[collectionObjectName];
        // console.log("newCollection=", newCollection);
        newCollection.splice(index, 1);
        // console.log("newCollection=", newCollection);
        return await this.updateObject(collectionName, id, { [collectionObjectName]: newCollection });
      }
    } catch (error) {
      throw error;
    }
  };

  deleteProperty = async (collectionName, id, propertyName) => {
    return await this.getOne(collectionName, id).then(async (retData) => {
      // let obj = retData;
      let properties = propertyName.split(".");
      // console.log("properties=", properties);
      // console.log("properties.length=", properties.length);
      if (properties.length === 1) {
        delete retData[propertyName];
      } else if (properties.length === 2) {
        // console.log("propertyName[0]=", properties[0], "propertyName[1]=", properties[1]);
        delete retData[properties[0]][properties[1]];
      } else if (properties.length === 3) {
        delete retData[properties[0]][properties[1]][properties[2]];
      } else if (properties.length === 4) {
        delete retData[properties[0]][properties[1]][properties[2]][properties[3]];
      }
      return await updateDoc(doc(db, collectionName, id), retData, { merge: true })
        .then((retValue) => {
          return retValue;
        })
        .catch((error) => {
          throw error;
        });
    }).catch((error) => {
      throw error;
    });
  };

  delete = async (collectionName, id) => {
    // console.log("delete(", collectionName, id, ")");
    return await this.updateActiveState(collectionName, id, false).catch((error) => {
      throw error;
    });
  };

  // /**
  //  * MÉTODO TEMPORÁRIO PARA USO LOCAL - Exclusão real no Firebase
  //  * ATENÇÃO: Este método executa exclusão permanente no banco de dados!
  //  * Só deve ser usado em ambiente de desenvolvimento/local para limpeza de dados de teste.
  //  * @param {string} collectionName - Nome da coleção
  //  * @param {string} id - ID do documento a ser excluído permanentemente
  //  * @returns {Promise} - Resultado da exclusão
  //  */
  // realDelete = async (collectionName, id) => {
  //   // Verificação de segurança - só executar em ambiente local
  //   const isLocal = window.location.hostname === 'localhost' || 
  //                  window.location.hostname === '127.0.0.1' || 
  //                  window.location.hostname.includes('192.168.');
    
  //   if (!isLocal) {
  //     throw new Error('⚠️ OPERAÇÃO BLOQUEADA: realDelete() só pode ser executado em ambiente local por segurança!');
  //   }

  //   console.warn('🚨 EXCLUSÃO REAL EXECUTADA:', { collectionName, id, timestamp: new Date().toISOString() });
    
  //   try {
  //     const docRef = doc(db, collectionName, id);
  //     await deleteDoc(docRef);
  //     console.log(`✅ Documento ${id} excluído permanentemente da coleção ${collectionName}`);
  //     return { success: true, message: `Documento ${id} excluído com sucesso` };
  //   } catch (error) {
  //     console.error(`❌ Erro ao excluir documento ${id}:`, error);
  //     throw error;
  //   }
  // };

  /**
   * Busca um único documento com fallback automático
   * Tenta primeiro via Firebase direto (mais rápido), depois via API se necessário
   * @param {string} collectionName - Nome da coleção
   * @param {string} id - ID do documento
   * @returns {Promise} - Dados do documento ou erro
   */
  getOneFromAPI = async (collectionName, id) => {
    try {
      if (!id) {
        return null;
      }

      // Primeira tentativa: acesso direto ao Firebase (mais rápido)
      try {
        const result = await this.getOne(collectionName, id);
        return result;
      } catch (firebaseError) {
        // Se erro de permissão, conexão ou limite, tentar API
        console.warn(`Erro no acesso direto ao Firebase para ${collectionName}/${id}:`, firebaseError.message);
        
        // Segunda tentativa: via API como fallback
        const requestData = {
          collectionName: collectionName,
          id: id.toString()
        };

        // 🔐 09/09/2026: /api/generic passou a exigir Bearer. Este fallback ia
        // sem token nenhum — e a rota lê com Admin SDK, por cima das Security
        // Rules. Agora vai autenticado como o usuário da sessão.
        const response = await AuthenticatedApiService.fetch('/api/generic/getOne', requestData);

        if (!response.ok) {
          // Se API também falhou, lançar erro original do Firebase
          console.error(`API também falhou (${response.status}). Erro original do Firebase:`, firebaseError.message);
          throw firebaseError;
        }

        const result = await response.json();

        if (result.success) {
          // Converter strings de data de volta para Timestamp antes de retornar
          const convertedData = this.convertDateStringsToTimestamp(result.data);
          return convertedData;
        } else {
          // Se não encontrou o documento, lançar erro similar ao método original
          if (response.status === 404) {
            throw new Error("Registro não encontrado! para o id: " + id + " na coleção: " + collectionName);
          } else {
            throw new Error(result.message || 'Erro ao buscar documento via API');
          }
        }
      }

    } catch (error) {
      console.error(`Erro final em getOneFromAPI para ${collectionName}/${id}:`, error);
      throw error;
    }
  };
}

export default new GenericService();
